import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout } from 'antd';
import Scrollbars from '@components/CustomScrollBar';
import appActions from '@stores/reducers/app/actions';
import Logo from '@components/Layout/Logo/Logo';
import BootstrapSidebar from './BootstrapSidebar';
import './Sidebar.css';
const { Sider } = Layout;

const { toggleOpenDrawer } = appActions;

export default function Sidebar() {
  const dispatch = useDispatch();
  const { collapsed, openDrawer, height } =
    useSelector((state) => state.App);

  const isCollapsed = collapsed && !openDrawer;
  const onMouseEnter = (event) => {
    if (collapsed && openDrawer === false) {
      dispatch(toggleOpenDrawer());
    }
    return;
  };
  const onMouseLeave = () => {
    if (collapsed && openDrawer === true) {
      dispatch(toggleOpenDrawer());
    }
    return;
  };
  const styling = {};

  return (
    <div style={{ position: 'relative' }}>
      <Sider
        trigger={null}
        collapsible={true}
        collapsed={isCollapsed}
        width={240}
        className="isomorphicSidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={styling}
      >
        <Logo collapsed={isCollapsed} linkTo="/" />
        <Scrollbars style={{ height: height - 70 }}>
          <BootstrapSidebar />
        </Scrollbars>
      </Sider>
    </div>
  );
}
